export default "__VITE_ASSET__DACMZeM9__"